import { Vector3 } from 'three'

type Point3 = { x: number; y: number; z: number }

const segmentLengthM = (a: Point3, b: Point3): number =>
  new Vector3(a.x, a.y, a.z).distanceTo(new Vector3(b.x, b.y, b.z))

type GuidToElementWithPositions = Record<
  string,
  ShapeObject | ShapeObjectLine | Rip | Lintel | undefined
>

/** Euclidean length (m) for a line member resolved via `guidToElement[guid]` (shape lines + rips/lintels). */
export function resolveLineMemberLengthFromGuidToElement(
  guid: string,
  guidToElement: GuidToElementWithPositions,
): number | null {
  const element = guidToElement[guid]
  if (!element) return null

  if ('shape' in element && element.shape && 'start' in element.shape && 'end' in element.shape) {
    const { start, end } = element.shape
    return segmentLengthM(start, end)
  }

  if (
    'element_type' in element &&
    (element.element_type === 'rips' || element.element_type === 'lintels') &&
    'start' in element &&
    'end' in element
  ) {
    return segmentLengthM(element.start, element.end)
  }

  return null
}
